module.exports = __webpack_public_path__ + "static/img/企业诚信官.c4618c6f.png";